import React from 'react';
import { useTheme } from '../../../../../../../theme';
const AirplaneOption = ({ icon, text }) => {
    const { AirplaneOption: css } = useTheme('Entities').SeatMap;
    return (React.createElement("div", { className: css.wrapper },
        React.createElement("span", { className: css.icon }, icon),
        React.createElement("div", { className: css.sunInfo__inner }, text)));
};
export default AirplaneOption;
